import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'direction', 'Direction', [["path",{"d":"M9 10l3 -3l3 3"}],["path",{"d":"M9 14l3 3l3 -3"}]]);